function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/**
 *  @class
 *  @function Quantity
 */
class QuantityInput {
  constructor(self, decreaseText, increaseText) {
    this.input = self.querySelector('.qty');
    this.changeEvent = new Event('change', {
      bubbles: true
    });
    // Create buttons
    this.subtract = self.querySelector('.minus');
    this.add = self.querySelector('.plus');

    // Add functionality to buttons
    this.subtract.addEventListener('click', () => this.change_quantity(-1));
    this.add.addEventListener('click', () => this.change_quantity(1));

    self.classList.add('buttons_added');
  }

  change_quantity(change) {
    // Get current value
    let quantity = Number(this.input.value);

    // Ensure quantity is a valid number
    if (isNaN(quantity)) quantity = 1;

    // Change quantity
    quantity += change;

    // Ensure quantity is always a number
    quantity = Math.max(quantity, 1);

    // Output number
    this.input.value = quantity;

    this.input.dispatchEvent(this.changeEvent);
  }
}
let quantities = document.querySelectorAll('.quantity:not(.buttons_added)');
quantities.forEach((quantity) => {
  new QuantityInput(quantity);
});

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
		this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
			this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
	class ProductCard extends HTMLElement {
		constructor() {
	    super();
			this.swatches = this.querySelector('.product-card-swatches');
	    this.image = this.querySelector('.product-featured-image-link .product-primary-image');
	    this.additional_images = this.querySelectorAll('.product-secondary-image');
			this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
	    this.quickview_button = this.querySelector('.product-card-quickview');
		}
		connectedCallback() {
			if (this.swatches) {
	      this.enableSwatches(this.swatches, this.image);
	    }
	    if (this.quickview_button) {
	      this.enableQuickview(this.quickview_button);
	    }
			if (this.additional_images) {
	      this.enableAdditionalImages();
	    }
		}
		enableAdditionalImages() {
				let image_length = this.additional_images.length;
				let images = this.additional_images;
				let nav = this.additional_images_nav;
				let image_container = this.querySelector('.product-featured-image');
				const mousemove = function(e) {
					let l = e.offsetX;
		      let w = this.getBoundingClientRect().width;
		      let prc = l/w;
		      let sel = Math.floor(prc*image_length);
		      let selimg = images[sel];
					images.forEach((image, index) => {
						if ( image.classList.contains('hover') ) {
							image.classList.remove('hover');
							nav[index].classList.remove('active');
						}
					});
					if ( selimg ) {
						if ( ! selimg.classList.contains('hover') ) {
				      selimg.classList.add('hover');
							nav[sel].classList.add('active');
						}
						image_container.classList.add('is-hovering-secondary');
					}

				};
				const mouseleave = function(e) {
					images.forEach((image, index) => {
						image.classList.remove('hover');
						nav[index].classList.remove('active');
					});
					image_container.classList.remove('is-hovering-secondary');
				};
				image_container.addEventListener( 'touchstart', mousemove );
				image_container.addEventListener( 'touchmove', mousemove );
				image_container.addEventListener( 'touchend', mouseleave );
				image_container.addEventListener( 'mouseenter', mousemove );
				image_container.addEventListener( 'mousemove', mousemove );
				image_container.addEventListener( 'mouseleave', mouseleave );
		}
		enableSwatches(swatches, image) {
	    let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
	      active = swatches.querySelector('.product-card-swatch.active');

	    swatch_list.forEach((swatch, index) => {

	      swatch.addEventListener('mouseover', function() {

	        [].forEach.call(swatch_list, function(el) {
	          el.classList.remove('active');
	        });
	        if (image) {
	          image.setAttribute('srcset', swatch.dataset.srcset);
	        }

	        swatch.classList.add('active');
	      });
	      swatch.addEventListener('click', function(evt) {
	        window.location.href = this.dataset.href;
	        evt.preventDefault();
	      });
	    });
	  }
	  enableQuickview(quickview_button) {
	    const _this = this,
	      drawer = document.getElementById('Product-Drawer'),
	      body = document.body;

			quickview_button.addEventListener('click', function(evt) {
	      evt.preventDefault();
	      let productHandle = quickview_button.dataset.productHandle,
	        	href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

	      // remove double `/` in case shop might have /en or language in URL
	      href = href.replace('//', '/');
	      if (!href || !productHandle) {
	        return;
	      }
	      if (quickview_button.classList.contains('loading')) {
	        return;
	      }
	      quickview_button.classList.add('loading');
	      fetch(href, {
	          method: 'GET'
	        })
	        .then((response) => {
	          quickview_button.classList.remove('loading');
	          return response.text();
	        })
	        .then(text => {
	          const sectionInnerHTML = new DOMParser()
	            .parseFromString(text, 'text/html')
	            .querySelector('#Product-Drawer-Content').innerHTML;
	          _this.renderQuickview(sectionInnerHTML, drawer, body);

	        });
	    });
	  }
	  renderQuickview(sectionInnerHTML, drawer, body) {
	    if (sectionInnerHTML) {
	      drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;
	      let quantity = drawer.querySelector('.quantity:not(.buttons_added)');
	      if (quantity) {
	        new QuantityInput(quantity);
	      }

	      setTimeout(() => {
	        if (Shopify && Shopify.PaymentButton) {
	          Shopify.PaymentButton.init();
	        }
	      }, 300);
	      body.classList.add('open-cc');
	      drawer.classList.add('active');
				setTimeout(() => {
		      drawer.querySelector('.product-quick-images--container').classList.add('active');
		    });
				drawer.querySelector('.side-panel-close').focus();
	    }
	  }
	}
	customElements.define('product-card', ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {

  constructor() {
		const header = document.getElementById('shopify-section-header'),
					header_main = document.getElementById("header"),
    			menu = document.getElementById('mobile-menu'),
				 	toggle = document.querySelector('.mobile-toggle-wrapper'),
					setHeaderOffset = this.setHeaderOffset,
					setAnnouncementHeight = this.setAnnouncementHeight,
					setHeaderHeight = this.setHeaderHeight;

    document.addEventListener('keydown', (e) => {
      if (e.code.toUpperCase() === 'ESCAPE') {
        toggle.removeAttribute('open');
				toggle.classList.remove('open');
      }
    });
		toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
			setAnnouncementHeight( header );
			if ( toggle.classList.contains('active')) {
				e.preventDefault();
				document.body.classList.remove('overflow-hidden');
				document.documentElement.classList.remove('overflow-hidden');
				toggle.classList.remove('active');
				this.closeAnimation(toggle);
			} else {
				document.body.classList.add('overflow-hidden');
				document.documentElement.classList.add('overflow-hidden');
				setTimeout(() => {
		      toggle.classList.add('active');
		    });
			}
			window.dispatchEvent( new Event('resize.resize-select') );
    });

		// Sticky Header Class
		if (header_main.dataset.sticky !== 'false') {
      document.documentElement.classList.add('sticky-header-active');
      let observer = new IntersectionObserver(function(entries) {
        if (entries[0].intersectionRatio === 0) {
          header_main.classList.add("is-sticky");
        } else if (entries[0].intersectionRatio === 1) {
          header_main.classList.remove("is-sticky");
        }
      }, {
        threshold: [0, 1]
      });
      observer.observe(document.querySelector(".header--sticky"));

      // Announcement bar hide on scroll down, show on scroll to top
      var annBarEl = document.getElementById('shopify-section-announcement-bar');
      if (annBarEl) {
        var annBarVisible = true;
        setAnnouncementHeight(annBarEl);
        // Enable transitions after first frame so there's no animation on page load
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            document.documentElement.classList.add('transitions-ready');
          });
        });
        function onAnnScroll() {
          var sy = window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
          if (sy > 1 && annBarVisible) {
            document.documentElement.classList.add('announcement-bar-hidden');
            annBarVisible = false;
          } else if (sy <= 0 && !annBarVisible) {
            document.documentElement.classList.remove('announcement-bar-hidden');
            annBarVisible = true;
          }
        }
        window.addEventListener('scroll', onAnnScroll, { passive: true });
      }
    }

		// Mobile Menu offset — skip updates while menu is open so height stays fixed
		window.addEventListener('scroll', function() {
			if (!toggle.classList.contains('active')) {
				setHeaderOffset(header);
				setHeaderHeight(header_main);
			}
		});
		window.dispatchEvent( new Event('scroll') );

		if ( document.getElementById('shopify-section-announcement-bar') ) {
			const a_bar = document.getElementById('shopify-section-announcement-bar');
			window.addEventListener('resize', function() {
				setAnnouncementHeight(a_bar);
			}, { passive: true } );
			window.dispatchEvent( new Event('resize') );
		}
		// Buttons.
		menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
		menu.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }
	setAnnouncementHeight(a_bar) {
		let h = a_bar.clientHeight;
		document.documentElement.style.setProperty('--announcement-height', h + 'px');
	}
	setHeaderOffset(header) {
		let h = header.getBoundingClientRect().top;
		document.documentElement.style.setProperty('--header-offset', h + 'px');
	}
	setHeaderHeight(header) {
		let h = header.clientHeight;
		document.documentElement.style.setProperty('--header-height', h + 'px');
	}
	onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.link-container');
    const isOpen = detailsElement.hasAttribute('open');

		setTimeout(() => {
			detailsElement.classList.add('menu-opening');
			parentMenuElement && parentMenuElement.classList.add('submenu-open');
		}, 100);
  }
	onCloseButtonClick(event) {
		event.preventDefault();
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }
	closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
		this.closeAnimation(detailsElement);
  }
	closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
	class FullMenu extends HTMLElement {
		constructor() {
	    super();

			this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
		}
		connectedCallback() {
			if (!this.submenus.length) {
				return;
			}
			const _this = this;
			// resize on initial load
			document.fonts.ready.then(function() {
				window.addEventListener('resize', debounce(function() {
					_this.resizeSubMenus();
				}, 100));
			});

		}
		resizeSubMenus() {
			this.submenus.forEach((submenu) => {
				let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

				sub_submenus.forEach((sub_submenu) => {
					let w = sub_submenu.offsetWidth,
							l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
							total = w + l;

					if ( total > window.innerWidth) {
						sub_submenu.parentElement.classList.add('left-submenu');
					} else if ( sub_submenu.parentElement.classList.contains('left-submenu') ) {
						sub_submenu.parentElement.classList.remove('left-submenu');
					}
				});
			});
		}
	}
	customElements.define('full-menu', FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
		super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keydown', (e) => {
      if (e.code.toUpperCase() === 'ESCAPE') {
        document.querySelectorAll('.side-panel').forEach((panel) => {
					if ( panel.classList.contains('product-drawer')) {
						if ( panel.querySelector('.product-quick-images--container') ) {

							panel.querySelector('.product-quick-images--container').classList.remove('active');
						}
						if ( window.innerWidth < 1069 ) {
							panel.classList.remove('active');
							document.body.classList.remove('open-cc');
						} else {
							if ( panel.querySelector('.product-quick-images--container') ) {
								panel.querySelector('.product-quick-images--container').addEventListener('transitionend', function() {
									panel.classList.remove('active');
									document.body.classList.remove('open-cc');
								});
							}
						}
					} else {
						panel.classList.remove('active');
				    document.body.classList.remove('open-cc');
					}
        });
      }
    });
    cc.addEventListener('click', (e) => {
			let panel = document.querySelector('.side-panel.active');
			if (panel) {
				if ( panel.classList.contains('product-drawer')) {
					panel.querySelector('.product-quick-images--container').classList.remove('active');
					if ( window.innerWidth < 1069 ) {
						panel.classList.remove('active');
						document.body.classList.remove('open-cc');
					} else {
						panel.querySelector('.product-quick-images--container').addEventListener('transitionend', function() {
							panel.classList.remove('active');
							document.body.classList.remove('open-cc');
						});
					}
				} else {
					panel.classList.remove('active');
			    document.body.classList.remove('open-cc');
				}
			}
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
		if ( panel.classList.contains('product-drawer')) {
			if ( panel.querySelector('.product-quick-images--container') ) {
				panel.querySelector('.product-quick-images--container').classList.remove('active');
			}
			if ( window.innerWidth < 1069 ) {
				panel.classList.remove('active');
				document.body.classList.remove('open-cc');
			} else {
				if ( panel.querySelector('.product-quick-images--container') ) {
					panel.querySelector('.product-quick-images--container').addEventListener('transitionend', function() {
						panel.classList.remove('active');
						document.body.classList.remove('open-cc');
					});
				}
			}
		} else {
			panel.classList.remove('active');
			document.body.classList.remove('open-cc');
		}

  }
}
customElements.define('side-panel-close', PanelClose);

/**
 * Keeps gift-wrap quantity aligned with the number of merchandise units for
 * cart integrations (such as Rebuy Smart Cart) that do not use CartDrawer.
 */
const GiftWrapQuantityGuard = {
  timer: null,
  verificationTimer: null,
  reconciling: false,
  rerun: false,
  pendingCart: null,

  // Shared definitions live on theme.giftWrap (layout/theme.liquid).
  isGiftWrapLine(item) {
    return theme.giftWrap.isLine(item);
  },

  isQualifyingLine(item) {
    return theme.giftWrap.isQualifying(item);
  },

  getChanges(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return [];
    }

    const giftWrapLines = cart.items.filter((item) => this.isGiftWrapLine(item));
    const productUnits = cart.items.reduce((total, item) => {
      return this.isQualifyingLine(item) ? total + item.quantity : total;
    }, 0);
    const giftWrapUnits = giftWrapLines.reduce((total, item) => total + item.quantity, 0);
    let excess = Math.max(0, giftWrapUnits - productUnits);
    const changes = [];

    for (let i = giftWrapLines.length - 1; i >= 0 && excess > 0; i--) {
      const giftWrapLine = giftWrapLines[i];
      const reduceBy = Math.min(excess, giftWrapLine.quantity);
      changes.push({
        id: giftWrapLine.key,
        quantity: giftWrapLine.quantity - reduceBy
      });
      excess -= reduceBy;
    }

    return changes;
  },

  reconcile(cart) {
    const changes = this.getChanges(cart);

    if (!changes.length) {
      return Promise.resolve({ cart, changed: false });
    }

    return changes.reduce((chain, change) => {
      return chain.then(() => fetch(theme.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(change)
      }).then((response) => {
        return response.json().then((parsedResponse) => {
          if (!response.ok) {
            throw parsedResponse;
          }
          return parsedResponse;
        });
      }));
    }, Promise.resolve(cart)).then((updatedCart) => ({ cart: updatedCart, changed: true }));
  },

  run(cart) {
    if (this.reconciling) {
      this.rerun = true;
      return;
    }

    this.reconciling = true;
    const cartRequest = cart && Array.isArray(cart.items)
      ? Promise.resolve(cart)
      : fetch(`${theme.routes.cart_url}.js`, {
          headers: { 'Accept': 'application/json' }
        })
      .then((response) => {
        return response.json().then((parsedResponse) => {
          if (!response.ok) {
            throw parsedResponse;
          }
          return parsedResponse;
        });
      });

    cartRequest
      .then((currentCart) => this.reconcile(currentCart))
      .then((result) => {
        if (result.changed && window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.setCart === 'function') {
          window.Rebuy.SmartCart.setCart(result.cart);
        }
      })
      .catch((error) => {
        console.error('Unable to reconcile gift-wrap quantity.', error);
      })
      .finally(() => {
        this.reconciling = false;
        if (this.rerun) {
          this.rerun = false;
          this.schedule();
        }
      });
  },

  schedule(cart) {
    if (cart && Array.isArray(cart.items)) {
      this.pendingCart = cart;
    }
    if (this.timer) {
      window.clearTimeout(this.timer);
    }
    this.timer = window.setTimeout(() => {
      this.timer = null;
      const pendingCart = this.pendingCart;
      this.pendingCart = null;
      this.run(pendingCart);
    }, 250);
  },

  verifyLater() {
    if (this.verificationTimer) {
      window.clearTimeout(this.verificationTimer);
    }
    this.verificationTimer = window.setTimeout(() => {
      this.verificationTimer = null;
      this.run();
    }, 1000);
  },

  preventOverLimitIncrease(event) {
    const button = event.target.closest && event.target.closest('button[aria-label^="Increase quantity of"]');
    const lineItem = button && button.closest('.rebuy-cart__flyout-item');
    const isGiftWrapItem = lineItem && (
      lineItem.classList.contains('property-_gift_wrap:true')
      || theme.giftWrap.handles.some((handle) => lineItem.classList.contains(`product-${handle}`))
    );
    if (!isGiftWrapItem) {
      return;
    }

    const smartCart = window.Rebuy && window.Rebuy.SmartCart;
    const items = smartCart && typeof smartCart.items === 'function' ? smartCart.items() : null;
    if (!Array.isArray(items)) {
      return;
    }

    const productUnits = items.reduce((total, item) => this.isQualifyingLine(item) ? total + item.quantity : total, 0);
    const giftWrapUnits = items.reduce((total, item) => this.isGiftWrapLine(item) ? total + item.quantity : total, 0);
    if (giftWrapUnits >= productUnits) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
};

window.GiftWrapQuantityGuard = GiftWrapQuantityGuard;
document.addEventListener('rebuy:cart.change', (event) => {
  const cart = event.detail && event.detail.cart ? event.detail.cart.cart : null;
  GiftWrapQuantityGuard.schedule(cart);
});
document.addEventListener('click', (event) => GiftWrapQuantityGuard.preventOverLimitIncrease(event), true);
[
  'rebuy:smartcart.ready',
  'rebuy:smartcart.line-item-increase',
  'rebuy:smartcart.line-item-decrease',
  'rebuy:smartcart.line-item-removed'
].forEach((eventName) => {
  document.addEventListener(eventName, () => GiftWrapQuantityGuard.verifyLater());
});

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

		if ( ! this.container ) {
			return;
		}
    let _this = this,
				button = document.getElementById('cart-drawer-toggle'),
	      quantities = this.container.querySelectorAll('.quantity input'),
	      removes = this.container.querySelectorAll('.remove');


    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      this.container.classList.add('active');
			this.container.focus();
      this.reconcileCart();
    });


    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

		this.notesToggle();
  }
  onChange(event) {
		if ( event.target.classList.contains('qty')) {
			this.updateQuantity(event.target.dataset.index, event.target.value);
		}
		this.removeProductEvent();
  }
	removeProductEvent() {
		let removes = this.container.querySelectorAll('.remove');

		removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
	notesToggle() {
		let notes_toggle = document.getElementById('order-note-toggle');

		if ( ! notes_toggle ) {
			return;
		}

		notes_toggle.addEventListener('click', (event) => {
			notes_toggle.nextElementSibling.classList.add('active');
		});
		notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
			el.addEventListener('click', (event) => {
				notes_toggle.nextElementSibling.classList.remove('active');
				this.saveNotes();
			});
		});
	}
	saveNotes() {
		fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': `application/json`
			},
    	body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
	}
  // Shared definitions live on theme.giftWrap (layout/theme.liquid).
  isGiftWrapLine(item) {
    return theme.giftWrap.isLine(item);
  }

  isQualifyingLine(item) {
    return theme.giftWrap.isQualifying(item);
  }
  removeOrphanedGiftWrap(parsedState) {
    if (!parsedState || !Array.isArray(parsedState.items)) {
      return Promise.resolve(parsedState);
    }

    const orphanedGiftWrap = parsedState.items.filter((item) => this.isGiftWrapLine(item));
    const hasSellableItems = parsedState.items.some((item) => this.isQualifyingLine(item));

    if (!orphanedGiftWrap.length || hasSellableItems) {
      return Promise.resolve(parsedState);
    }

    // Only gift-wrap lines remain — strip them so a gift-wrap-only cart can't reach checkout.
    const sections = this.getSectionsToRender().map((section) => section.section);

    return orphanedGiftWrap.reduce((chain, item) => {
      return chain.then(() => fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0,
          sections,
          sections_url: window.location.pathname
        })
      }).then((response) => response.json()));
    }, Promise.resolve(parsedState));
  }
  capGiftWrapQuantity(parsedState) {
    if (!parsedState || !Array.isArray(parsedState.items)) {
      return Promise.resolve(parsedState);
    }

    const giftWrapLines = parsedState.items.filter((item) => this.isGiftWrapLine(item));
    if (!giftWrapLines.length) {
      return Promise.resolve(parsedState);
    }

    const productUnits = parsedState.items.reduce((total, item) => {
      return this.isQualifyingLine(item) ? total + item.quantity : total;
    }, 0);
    const giftWrapUnits = giftWrapLines.reduce((total, item) => total + item.quantity, 0);

    if (giftWrapUnits <= productUnits) {
      return Promise.resolve(parsedState);
    }

    // Gift wraps can't exceed the number of products in the cart — trim the excess wrap units.
    let excess = giftWrapUnits - productUnits;
    const sections = this.getSectionsToRender().map((section) => section.section);
    const changes = [];
    for (let i = giftWrapLines.length - 1; i >= 0 && excess > 0; i--) {
      const gwLine = giftWrapLines[i];
      const reduceBy = Math.min(excess, gwLine.quantity);
      changes.push({ key: gwLine.key, quantity: gwLine.quantity - reduceBy });
      excess -= reduceBy;
    }

    return changes.reduce((chain, change) => {
      return chain.then(() => fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: change.key,
          quantity: change.quantity,
          sections,
          sections_url: window.location.pathname
        })
      }).then((response) => response.json()));
    }, Promise.resolve(parsedState));
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
      .then((response) => {
        return response.text();
      })
      .then((state) => this.removeOrphanedGiftWrap(JSON.parse(state)))
      .then((parsedState) => this.capGiftWrapQuantity(parsedState))
      .then((parsedState) => {
        this.renderSections(parsedState);
				if ( this.container.querySelector(`#CartDrawerItem-${line}`).length ) {
	        this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
				}
      });
  }
  /*
   * The drawer's orphan and cap guards otherwise only run after a quantity change, so a
   * cart that is already wrap-only when the drawer opens is checked here first.
   */
  reconcileCart() {
    fetch(`${theme.routes.cart_url}.js`, { headers: { 'Accept': 'application/json' } })
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((state) => this.removeOrphanedGiftWrap(state))
      .then((parsedState) => this.capGiftWrapQuantity(parsedState))
      .then((parsedState) => {
        // Only a /cart/change response carries `sections`; /cart.js on its own means no change.
        if (parsedState && parsedState.sections) {
          this.renderSections(parsedState);
        }
      })
      .catch((error) => {
        console.error('Unable to reconcile gift wrap in the cart drawer.', error);
      });
  }
  renderSections(parsedState) {
        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

          let quantities = elementToReplace.querySelectorAll('.quantity:not(.buttons_added)');
					let removes = this.container.querySelectorAll('.remove');
          if (quantities) {
            quantities.forEach((quantity) => {
              new QuantityInput(quantity);
            });
          }
					if (removes) {
						removes.forEach((remove) => {
				      remove.addEventListener('click', (event) => {
				        this.updateQuantity(event.target.dataset.index, '0');

				        event.preventDefault();
				      });
				    });
					}
					this.notesToggle();

        }));
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
		this.querySelectorAll('.js-youtube').forEach((video) => {
	    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
	  });
	  this.querySelectorAll('.js-vimeo').forEach((video) => {
	    video.contentWindow.postMessage('{"method":"pause"}', '*');
	  });
		this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
		let _this = this;
		// resize on initial load
		document.querySelectorAll(".thb-localization-forms").forEach((localization) => {
			localization.addEventListener("change", (e) => {
				localization.querySelector('form').submit();
			});
		});
	}
}



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
		let _this = this;
		// resize on initial load
		document.fonts.ready.then(function() {
			document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
		});

		// delegated listener on change
		document.body.addEventListener("change", (e) => {
	    if (e.target.matches(".resize-select") && e.target.offsetParent !== null) {
	       _this.resizeSelect(e.target);
	    }
		});
		window.addEventListener('resize.resize-select', function() {
			document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
		});
	}

	resizeSelect(sel) {
	  let tempOption = document.createElement('option');
	  tempOption.textContent = sel.selectedOptions[0].textContent;

	  let tempSelect = document.createElement('select');
	  tempSelect.style.visibility = "hidden";
	  tempSelect.style.position = "fixed";
	  tempSelect.appendChild(tempOption);

	  sel.after(tempSelect);
		if ( tempSelect.clientWidth > 0 ) {
		  sel.style.width = `${+tempSelect.clientWidth + 12}px`;
		}
	  tempSelect.remove();
	}
}

if (typeof SelectWidth !== 'undefined') {
	new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
		let _this = this;
		// resize on initial load
		document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
			button.addEventListener("click", (e) => {
		    button.classList.toggle('active');
			});
		});
	}
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
	class SidePanelContentTabs extends HTMLElement {
		constructor() {
	    super();
			this.buttons = this.querySelectorAll('button');
			this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
	  }
		connectedCallback() {
			this.setupButtonObservers();
		}
		disconnectedCallback() {

		}
		setupButtonObservers() {
			this.buttons.forEach((item, i) => {
				item.addEventListener('click', (e) => {
					this.toggleActiveClass(i);
				});
			});
		}
		toggleActiveClass(i) {
			this.buttons.forEach((button) => {
				button.classList.remove('tab-active');
			});
			this.buttons[i].classList.add('tab-active');

			this.panels.forEach((panel) => {
				panel.classList.remove('tab-active');
			});
			this.panels[i].classList.add('tab-active');
		}
	}

	customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

window.addEventListener('load', () => {

	if (typeof window.Rebuy !== 'undefined') {
		GiftWrapQuantityGuard.schedule();
	}

	if (typeof Localization !== 'undefined') {
		new Localization();
	}
	if (typeof CartDrawer !== 'undefined') {
	  new CartDrawer();
	}
	if (typeof Header !== 'undefined') {
	  new Header();
	}
	if (typeof FooterMenuToggle !== 'undefined') {
		new FooterMenuToggle();
	}
});

// Ensure side cart always opens and search drawer always opens
document.addEventListener('click', function (e) {
  const cartToggle = e.target.closest('#cart-drawer-toggle, .thb-secondary-cart');
  if (cartToggle) {
    e.preventDefault();
    e.stopPropagation();
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function' && window.Rebuy.SmartCart.settings && window.Rebuy.SmartCart.settings.enabled) {
      window.Rebuy.SmartCart.show();
    } else {
      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        document.body.classList.add('open-cc');
        cartDrawer.classList.add('active');
        cartDrawer.focus();
      }
    }
    return false;
  }

  const searchToggle = e.target.closest('.thb-quick-search');
  if (searchToggle) {
    e.preventDefault();
    e.stopPropagation();
    const searchDrawer = document.getElementById('Search-Drawer');
    if (searchDrawer) {
      document.body.classList.add('open-cc');
      searchDrawer.classList.add('active');
      const input = searchDrawer.querySelector('input[type="search"]');
      if (input) {
        setTimeout(function () {
          input.focus({ preventScroll: true });
        }, 100);
      }
    }
    return false;
  }
}, true);

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' || e.code === 'Escape') {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.hide === 'function') {
      window.Rebuy.SmartCart.hide();
    }
  }
});


